import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-gz-logistics-search',
  templateUrl: './gz-logistics-search.component.html',
  styleUrls: ['./gz-logistics-search.component.css']
})
export class GzLogisticsSearchComponent implements OnInit {

  userId: any;
  userName: any;

  keyWord: any;

  constructor(private routerInfo: ActivatedRoute, private titleService: Title,
              private router: Router) {
    this.userId = this.routerInfo.snapshot.queryParams['userId'];
    this.userName = this.routerInfo.snapshot.queryParams['userName'];
  }

  ngOnInit() {
    this.titleService.setTitle('物流商务诚信信息查询');
  }

  /**
   * 键盘键入事件
   * @param event
   */
  inputSomething(event: any) {
    if (event.keyCode == 13) {// enter
      this.router.navigate(['/searchParent'], {queryParams:{keyWord: this.keyWord}});
    }
  }

}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/components/gz-logistics-search/gz-logistics-search.component.ts